export default __webpack_public_path__ + "af08a99c99f2a406bb6e3f48a99ae757.png";